import React, { useState, useEffect } from 'react';
import { Button, ButtonGroup, Form, Card, Modal, Col, Row, ProgressBar, Alert, Accordion } from 'react-bootstrap';
import { Table, Segment, Header } from "semantic-ui-react";
import Amplify, { Auth, Storage, API } from 'aws-amplify';
import cookie from 'react-cookies';
import fastaParser from './FastaJS';
import { message } from 'antd';

function Email() {

	Date.prototype.format = function (fmt) {
		var o = {
			"M+": this.getMonth() + 1,                   //月份
			"d+": this.getDate(),                        //日
			"h+": this.getHours(),                       //小时
			"m+": this.getMinutes(),                     //分
			"s+": this.getSeconds(),                     //秒
			"q+": Math.floor((this.getMonth() + 3) / 3), //季度
			"S": this.getMilliseconds()                  //毫秒
		};

		//  获取年份 
		// ①
		if (/(y+)/i.test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
		}

		for (var k in o) {
			// ②
			if (new RegExp("(" + k + ")", "i").test(fmt)) {
				fmt = fmt.replace(
					RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
			}
		}
		return fmt;
	}

	const [user, setUser] = useState(null);
	const [email, setEmail] = useState(null);
	const [type, setType] = useState(null);
	const [error, setError] = useState(null);
	const [warning, setWarning] = useState(null);
	const [file_pdb, setFile_pdb] = useState();
	const [file_sdf, setFile_sdf] = useState();
	const [path, setPath] = useState(null);
	const [path_l, setPath_l] = useState(null);
	const [progress, setProgress] = useState(0);
	const [progress_s, setProgress_s] = useState(0);
	const [progress_l, setProgress_l] = useState(0);
	const [progress_af, setProgress_af] = useState(0);
	const [show, setShow] = useState(false);
	const [show_e, setShow_e] = useState(false);
	const [show_e1, setShow_e1] = useState(false);
	const [disable, setDisable] = useState(true);
	const [disable_s, setDisable_s] = useState(true);
	const [disable_l, setDisable_l] = useState(true);
	const [disable_af, setDisable_af] = useState(true);
	const [disable_double, setDisable_double] = useState(true);
	const [disable_op, setDisable_op] = useState(true);

	const [add, setAdd] = useState("No");
	const [fastaCount, setFastaCount] = useState();
	const [fileAF, setFileAF] = useState();
	const [UID, setUID] = useState();
	const [timeStamp, setTimeStamp] = useState();




	const [show1, setShow1] = useState(false);

	const handleClose1 = () => {
		setShow1(false);

		setTimeout(
			() => {
				window.location.href = "/submit";
			},
			500
		);
	};
	const handleShow1 = () => setShow1(true);

	const [show2, setShow2] = useState(false);

	const handleClose2 = () => {
		setShow2(false);

		setTimeout(
			() => {
				window.location.href = "/submit";
			},
			500
		);
	};
	const handleShow2 = () => setShow2(true);

	const [show3, setShow3] = useState(false);

	const handleClose3 = () => {
		setShow3(false);

		setTimeout(
			() => {
				window.location.href = "/submit";
			},
			500
		);
	};
	const handleShow3 = () => setShow3(true);



	var file;
	var filename;
	var Path;
	var Path_l;
	var CurrentError;
	var CurrentWarning;

	const Bucket = "s3://p450-result-prod/public/";

	function handleUser(e) {
		let currentuser = e.target.value;
		setUser(currentuser);
	}

	function emailCheck(emailAddr) {
		if ((emailAddr == null) || (emailAddr.length < 2)) return false;

		// 需出现'@',且不在首字符.
		var aPos = emailAddr.indexOf("@", 1);

		if (aPos < 0) {
			return false;
		}

		// '@'后出现'.',且不紧跟其后.
		if (emailAddr.indexOf(".", aPos + 2) < 0) {
			return false;
		}

		return true;
	}

	function handleEmail(e) {
		let currentEmail = e.target.value;
		var isEmail = emailCheck(currentEmail);
		console.log(isEmail);
		if (!isEmail) {
			setWarning('Incorrect Email');
			CurrentWarning = 'Incorrect Email';
			setShow_e1(true);
			setDisable_op(true);
			console.log('Incorrect Email');

		} else {
			setEmail(currentEmail);
			setShow_e1(false);
			setDisable_op(false);
		}





	}

	function handleType(e) {
		setType(null);
		let currentType = e.target.value;
		setType(currentType);
		if (currentType == "PCPCM") {

			setShow1(true);
			setShow2(false);
			setShow3(false);


		} else if (currentType == "PCPLD") {

			setShow1(false);
			setShow2(true);
			setShow3(false);


		} else if (currentType == "AlphaFold-P450") {

			setShow1(false);
			setShow2(false);
			setShow3(true);


		}

	}

	function handleFile(e) {
		const fileS = e.target.files[0];
		let filenameS = fileS.name;
		
		console.log(filenameS);
		Storage.put(filenameS, fileS, {
			progressCallback(progress) {
				var percentage = (progress.loaded / progress.total * 100).toFixed(1);
				setProgress(percentage);
				setProgress_s(percentage);
				console.log(percentage);
			}
		})
			.then(result => {
				console.log(result);
				Path = Bucket + filenameS;
				setPath(Path);
				console.log(Path);
				setDisable(false);

			})
			.catch(err => {
				console.log(err);
			});
	}

	function handleFile_s(e) {
		const fileS = e.target.files[0];
		let filenameS = new Date().valueOf()+".pdb";
		setFile_pdb(fileS.name);
		// console.log(filenameS);
		Storage.put("gnina/"+filenameS, fileS, {
			progressCallback(progress) {
				var percentage = (progress.loaded / progress.total * 100).toFixed(1);

				setProgress_s(percentage);
				console.log(percentage);
			}
		})
			.then(result => {
				console.log(result);
				Path = Bucket + "gnina/" + filenameS;
				setPath(Path);
				console.log(Path);
				setDisable(false);
				setDisable_s(false);
			})
			.catch(err => {
				console.log(err);
			});
	}

	useEffect(() => {
		function DoubleDisable_l() {
			if (disable_s == false) {
				setDisable_double(false);
			}
		}
		if (disable_l == false) {
			DoubleDisable_l();
		}
	}, [disable_l])

	useEffect(() => {
		function DoubleDisable_s() {
			if (disable_l == false) {
				setDisable_double(false);
			}
		}
		if (disable_s == false) {
			DoubleDisable_s();
		}
	}, [disable_s])

	function handleFile_l(e) {
		const fileL = e.target.files[0];
		let filenameL = new Date().valueOf()+".sdf";
		setFile_sdf(fileL.name)
		// console.log(filenameL);
		Storage.put("gnina/"+filenameL, fileL, {
			progressCallback(progress_l) {
				var percentage_L = (progress_l.loaded / progress_l.total * 100).toFixed(1);
				setProgress_l(percentage_L);
				console.log(percentage_L);
			}
		})
			.then(result => {
				console.log(result);
				Path_l = Bucket + "gnina/" + filenameL;
				setPath_l(Path_l);
				console.log(Path_l);
				setDisable_l(false);
			})
			.catch(err => {
				console.log(err);
			});
	}

	function handleFile_af() {
		let ts = new Date();
		setTimeStamp(ts);
		let filenameAF = ts.valueOf() + "/" + "AlphaFold-P450-" + ts.valueOf() + ".fasta";
		let currentID = "AlphaFold-P450-" + ts.valueOf();
		setUID(currentID);

		var reader = new FileReader();
		reader.readAsText(fileAF);
		reader.onload = function () {
			// console.log(this.result);
			let check = checkFastaFile(this.result);
			if (check) {
				Storage.put(filenameAF, fileAF, {
					progressCallback(progress) {
						var percentage = (progress.loaded / progress.total * 100).toFixed(1);
		
						setProgress_af(percentage);
						console.log(percentage);
					}
				})
					.then(result => {
						console.log(result);
						Path = Bucket + filenameAF;
						setPath(Path);
						console.log(Path);
						setDisable_af(false);
					})
					.catch(err => {
						console.log(err);
					});
			} else {
				alert("Not FASTA format.");
			}
		}

		
	}

	function checkFile(params) {
		setFileAF(params.target.files[0]);
		const reader = new FileReader();
		reader.readAsText(params.target.files[0]);
		reader.onload = function (e) {
			// console.log(e.target.result);
			const current = e.target.result;
			let arr_1 = current.replaceAll("\n", "&@%$\n").split("\n");
			var count_sequence = 0;
			if (current.startsWith(">")) {
				for (let i = 0; i < arr_1.length; i++) {
					if (arr_1[i].startsWith(">") && arr_1[i].endsWith("&@%$")) {
						count_sequence++;
					}
				}
				setFastaCount(count_sequence);

			} else {
				setFastaCount(0);
			}
		};
	}

	function checkFastaFile(params) {

		if (params.startsWith(">")) {
			let props = params.replaceAll("\r", "");
			var options = {
				'definition': 'gi|accession|description',
				'delimiter': '|'
			};

			var fasta = new fastaParser(options);

			let currentArr = fasta.parse(props);
			// console.log(currentArr);
			for (let i = 0; i < currentArr.length; i++) {
				if(currentArr[i].sequence.replaceAll("\n", "").endsWith("*")){
					if (currentArr[i].sequence.replaceAll("\n", "").slice(0, -1).match(/[^ARNDCQEGHILKMFPSTWXYVUOBZJarndcqeghikmfpstwxyvuobzj]/g)) {
						// console.log("mark:", currentArr[0].sequence.replaceAll("\n", "").match(/[^ARNDCQEGHILKMFPSTWXYVUOBZJarndcqeghikmfpstwxyvuobzj]/g));
						console.log("Not FASTA FORMAT");
						return false;
					}
				}else{
					if (currentArr[i].sequence.replaceAll("\n", "").match(/[^ARNDCQEGHILKMFPSTWXYVUOBZJarndcqeghikmfpstwxyvuobzj]/g)) {
						// console.log("mark:", currentArr[0].sequence.replaceAll("\n", "").match(/[^ARNDCQEGHILKMFPSTWXYVUOBZJarndcqeghikmfpstwxyvuobzj]/g));
						console.log("Not FASTA FORMAT");
						return false;
					}
				}
				
			}

			return true

		} else {
			console.log("Not FASTA FORMAT");
			return false;
		}
	}

	useEffect(() => {
		if (fastaCount !== undefined) {
			if (fastaCount === 0) {
				alert("File Error.");
			} else if (fastaCount > 10) {
				alert("Too many sequences.");
			} else {
				handleFile_af();
			}
		}
	}, [fastaCount])



	function handleSubmit() {
		let ts = new Date();
		let currentDate = ts.format("yyyyMMdd");
		let currentUID = "Gnina-P450-" + ts.valueOf();

		let currentInfo = {
			UserName: user,
			Email: email,
			JobType: type,
			PdbFile: path,
			LigandFile: path_l

		}



		if (user != null && email != null) {
			if (type == "PCPCM") {
				if (path != null) {
					console.log("Success");
					// if(error != null) {
					setError(null);
					CurrentError = null;
					setShow_e(false);
					setShow(true);

					// }
				} else {
					setError("Param Missing");
					CurrentError = "Param Missing";
					setShow(false);
					setShow_e(true);
				}

			} else if (type == "PCPLD") {
				if (path != null && path_l != null) {
					console.log("Success");
					// if(error != null) {
					setError(null);
					CurrentError = null;
					setShow_e(false);
					setShow(true);

					// }
				} else {
					setError("Param Missing");
					CurrentError = "Param Missing";
					setShow(false);
					setShow_e(true);
				}
			}
		} else {
			setError("Param Missing");
			CurrentError = "Param Missing";
			setShow(false);
			setShow_e(true);
		}

		if (CurrentError == null) {
			let currentParams = {
				"UserName": user,
				"ID": currentUID,
				"Timestamp": ts.valueOf(),
				"Email": email,
				"Job_Type": "gnina_png",
				"Pdb_Name": file_pdb,
				"Sdf_Name": file_sdf,
				"Pdb_s3_path": path,
				"Sdf_s3_path": path_l
			};
			// console.log("currentParams:", currentParams);

			async function postSP() {
				// Amplify.Logger.LOG_LEVEL = "DEBUG";

				const session = await Auth.currentCredentials();
				console.log(session)
				const apiRequest = {
					body: {
						"Username": user,
						"ID": currentUID,
						"Timestamp": ts.valueOf(),
						"Email": email,
						"Job_Type": "gnina_png",
						"JobType": type,
						"Pdb_Name": file_pdb,
						"Sdf_Name": file_sdf,
						"Pdb_s3_path": path,
						"Sdf_s3_path": path_l
					},
					headers: {
						"Content-Type": "application/json",

					},
				};

				return await API
					.post("P450", "/gnina", apiRequest)
					.then(
						(data) => {
							console.log(data);
							if(data.statusCode === 200){
								saveParams(currentUID, currentParams);
								setShow1(false);
								setShow2(false);
								setTimeout(
									() => {
										window.location.href = "/pcpld_results";
									},
									3000
								);
							}
							
						},
						(error) => {
							console.log(error);
						}
					);
			};
			postSP();
		}


	}

	function saveParams(param1, param2) {
		let inFifteenMinutes = new Date(new Date().getTime() + 24 * 3600 * 1000 * 30);   //  30 days
		let Name = param1;
		let Value = param2;
		cookie.save(Name, Value, { expires: inFifteenMinutes });
	}



	function handleSubmit_af() {
		let current = {
			"Name": fileAF.name,
			"ID": UID,
			"Hem": add,
			"Timestamp": timeStamp.valueOf(),
			"Number": fastaCount,
			"Status": "Queued"
		};
		console.log(current);

		async function postAF() {
			// Amplify.Logger.LOG_LEVEL = "DEBUG";

			const session = await Auth.currentCredentials();
			console.log(session)
			const apiRequest = {
				body: {
					"Username": user,
					"Email": email,
					"Number": fastaCount,
					"Name": fileAF.name,
					"Type": "AlphaFold-P450",
					"Timestamp": timeStamp.valueOf(),
					"ID": UID,
					"Hem": add,
					"Sequence_s3_path": path

				},
				headers: {
					"Content-Type": "application/json",

				},
			};

			return await API
				.post("P450", "/alphafold2", apiRequest)
				.then(
					(data) => {
						console.log(data);
						saveParams(UID, current);
						setShow(true);
						setTimeout(
							() => {
								window.location.href = "/results";
							},
							3000
						);
					},
					(error) => {
						console.log(error);
						alert("Network Error!");
						window.location.href = "/submit";
					}
				);
		};
		postAF();
	}

	return (
		<div style={{
			background: "#FFFFFF"

		}}>

			<Row>
				<Col>
				</Col>
				<Col md={10}>

					<div style={{

						height: "50px"
					}}>
					</div>
					<div>
						<Accordion>
							<Card>
								<Card.Header>
									<Accordion.Toggle as={Header} eventKey="0" textAlign='center'>
										<span style={{ color: "#6495ED" }} >User Guide</span>
									</Accordion.Toggle>
								</Card.Header>
								<Accordion.Collapse eventKey="0">
									<Card.Body>
										<Segment basic>
											<Row>
												<Col md={1} />
												<Col>
													<p>AlphaFold-P450 is used to predict the structure of plant P450s. PCPLD is used to dock the ligand with plant P450s. Usage as below:</p>
													<p>Step 1: Please input your own name and email.</p>
													<p>Step 2: Please choose a tool, AlphaFold-P450 or PCPLD.</p>
													<p>Step 3: Please upload the file in the following format:</p>
													<p><small>To use AlphaFold-P450, you need to upload a P450 protein sequence file in FASTA format.</small></p>
													<p><small>To use PCPLD, you need to upload a P450 protein sequence file in FASTA format (or a plant P450 protein structure file in PDB format) and a ligand file in SDF format.</small></p>
													<p>Step 4: Submit.</p>
													<p>(The program will take some time to run, and we will send the results to you by email as soon as it completes, you can also download the predictive structure in menu of Tools-Results.)</p>
												</Col>
												<Col md={1} />
											</Row>
										</Segment>
									</Card.Body>
								</Accordion.Collapse>
							</Card>

						</Accordion>

						<Accordion defaultActiveKey="1">
							<Card>
								<Card.Header>
									<Accordion.Toggle as={Header} eventKey="1" textAlign='center'>
										<span style={{ color: "#6495ED" }} >Tools</span>
									</Accordion.Toggle>
								</Card.Header>
								<Accordion.Collapse eventKey="1">
									<Card.Body>
										<Alert show={show_e1} variant="warning" onClose={() => setShow_e1(false)} dismissible>
											<Alert.Heading>Warning</Alert.Heading>
											<p>{warning}</p>
										</Alert>
										<Form>
											<Form.Group as={Row} controlId="formBasicUserName">
												<Col sm="1"></Col>
												<Form.Label column sm="2" style={{ textAlign: "right" }}>
													User Name:
												</Form.Label>
												<Col sm="8">
													<Form.Control type="text" placeholder="User Name" onChange={handleUser} />
												</Col>

												<Col sm="1"></Col>
											</Form.Group>

											<Form.Group as={Row} controlId="formBasicEmail">
												<Col sm="1"></Col>
												<Form.Label column sm="2" style={{ textAlign: "right" }}>
													Email:
												</Form.Label>

												<Col sm="8">
													<Form.Control type="email" placeholder="Email" onChange={handleEmail} />
												</Col>
												<Col sm="1"></Col>
											</Form.Group>

											<Form.Group as={Row} controlId="formBasicType">
												<Col sm="1"></Col>
												<Form.Label column sm="2" style={{ textAlign: "right" }}>
													Job Type:
												</Form.Label>

												<Col sm="8">
													<Form.Control as="select" onChange={handleType} disabled={disable_op}>
														<option>Please Select</option>
														<option>AlphaFold-P450</option>
														<option>PCPLD</option>

													</Form.Control>
												</Col>
												<Col sm="1"></Col>
											</Form.Group>

											<Row>
												<Col sm="3"></Col>
												<Col sm="8">
													<Form.Text className="text-muted">
														Note: Per email can only submit 3 tasks per day.
													</Form.Text>
												</Col>
												<Col sm="1"></Col>
											</Row>

										</Form>
									</Card.Body>
								</Accordion.Collapse>
							</Card>

						</Accordion>

					</div>


					<div>


						<div>

						</div>

						<div>
							<Modal show={show1} onHide={handleClose1}>
								<Modal.Header closeButton>
									<Modal.Title>Upload</Modal.Title>
								</Modal.Header>
								<Modal.Body>
									<Alert show={show} variant="success" onClose={() => setShow(false)} dismissible>
										<Alert.Heading>Success</Alert.Heading>
										<p>After 3 seconds the page will automatically refresh...</p>
									</Alert>
									<Alert show={show_e} variant="danger" onClose={() => setShow_e(false)} dismissible>
										<Alert.Heading>Error</Alert.Heading>
										<p>{error}</p>
									</Alert>
									<Form.Group as={Row} controlId="formBasicFile">
										<Form.Label column sm="5">
											Protein sequence file:
										</Form.Label>
										<Col sm="7">
											<Form.File id="exampleFormControlFile1" onChange={handleFile} />
										</Col>
									</Form.Group>

									<Form.Group>
										<ProgressBar variant="success" now={progress} label={`${progress}%`} />
									</Form.Group>
								</Modal.Body>
								<Modal.Footer>
									<Button variant="secondary" onClick={handleClose1}>
										Close
									</Button>
									<Button variant="primary" onClick={handleSubmit} disabled={disable}>
										Submit
									</Button>
								</Modal.Footer>
							</Modal>
						</div>

						<div>
							<Modal show={show2} onHide={handleClose2}>
								<Modal.Header closeButton>
									<Modal.Title>Upload</Modal.Title>
								</Modal.Header>
								<Modal.Body>
									<Alert show={show} variant="success" onClose={() => setShow(false)} dismissible>
										<Alert.Heading>Success</Alert.Heading>
										<p>After 3 seconds the page will automatically refresh...</p>
									</Alert>
									<Alert show={show_e} variant="danger" onClose={() => setShow_e(false)} dismissible>
										<Alert.Heading>Error</Alert.Heading>
										<p>{error}</p>
									</Alert>
									<Form.Group as={Row} controlId="formBasicFile">
										<Form.Label column sm="5">
											Protein sequence/structure file:
										</Form.Label>
										<Col sm="7">
											<Form.File id="exampleFormControlFile1" onChange={handleFile_s} accept=".pdb" />
										</Col>
									</Form.Group>

									<Form.Group>
										<ProgressBar variant="success" now={progress_s} label={`${progress_s}%`} />
									</Form.Group>

									<Form.Group as={Row} controlId="formBasicFile">
										<Form.Label column sm="5">
											Ligand file:
										</Form.Label>
										<Col sm="7">
											<Form.File id="exampleFormControlFile1" onChange={handleFile_l} accept=".sdf" />
										</Col>
									</Form.Group>

									<Form.Group>
										<ProgressBar variant="success" now={progress_l} label={`${progress_l}%`} />
									</Form.Group>
								</Modal.Body>
								<Modal.Footer>
									<Button variant="secondary" onClick={handleClose2}>
										Close
									</Button>


									<Button variant="primary" onClick={handleSubmit} disabled={disable_double}>
										Submit
									</Button>

								</Modal.Footer>
							</Modal>
						</div>

						<div>
							<Modal show={show3} onHide={handleClose3}>
								<Modal.Header closeButton>
									<Modal.Title>Upload</Modal.Title>
								</Modal.Header>
								<Modal.Body>
									<Alert show={show} variant="success" onClose={() => setShow(false)} dismissible>
										<Alert.Heading>Success</Alert.Heading>
										<p>After 3 seconds the page will automatically refresh...</p>
									</Alert>
									<Alert show={show_e} variant="danger" onClose={() => setShow_e(false)} dismissible>
										<Alert.Heading>Error</Alert.Heading>
										<p>{error}</p>
									</Alert>
									<Form.Group as={Row} controlId="formBasicFile">
										<Form.Label column sm="5">
											Protein sequences:
										</Form.Label>
										<Col sm="7">
											<Form.File id="exampleFormControlFile1" onChange={checkFile} accept=".fasta" />
											<Form.Text className="text-muted">Max Length: 10 sequences</Form.Text>
										</Col>
									</Form.Group>



									<Form.Group>
										<ProgressBar variant="success" now={progress_af} label={`${progress_af}%`} />
									</Form.Group>

									{/* <Form.Group className="mb-3" controlId="formBasicCheckbox">
									<Form.Check type="checkbox" label="Add HEM" onChange={(e)=>setAdd(e.target.value)} />
								</Form.Group> */}

									<Form.Group as={Row} controlId="formBasicFile">
										<Form.Label column sm="5">
											Add HEM:
										</Form.Label>
										<Col sm="7">
											<Form.Check
												type="radio"
												inline
												label="Yes"
												name="formHorizontalRadios"
												id="formHorizontalRadios1"
												onChange={() => setAdd("Yes")}
											/>
											<Form.Check
												type="radio"
												inline
												label="No"
												name="formHorizontalRadios"
												id="formHorizontalRadios2"
												defaultChecked
												onChange={() => setAdd("No")}
											/>
										</Col>
									</Form.Group>

								</Modal.Body>
								<Modal.Footer>
									<Button variant="secondary" onClick={handleClose3}>
										Close
									</Button>


									<Button variant="primary" onClick={handleSubmit_af} disabled={disable_af} >
										Submit
									</Button>

								</Modal.Footer>
							</Modal>
						</div>


					</div>
					<div style={{

						height: "50px"
					}}>
					</div>
				</Col>
				<Col>
				</Col>
			</Row>
		</div>

	);
}

export default Email;